import React from "react";
import { Field, Formik, FastField } from "formik";
import { object, number } from "yup";
import { Col, Form } from "react-bootstrap";
import { Api } from "../../utils/api";
import { MaterialSelectFormik } from "../components/select-field.component";
import { TextField, CheckboxWithLabel } from "formik-material-ui";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Slider from "@material-ui/core/Slider";
import {
  Map,
  Marker,
  Popup,
  TileLayer,
  withLeaflet,
  Circle,
  ZoomControl,
} from "react-leaflet";
import { ReactLeafletSearch } from "react-leaflet-search";
import L from "leaflet";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Tooltip } from "@material-ui/core";

const ReactLeafletSearchV2 = withLeaflet(ReactLeafletSearch);

const shouldUpdateSelect = (prevProps, props) => {
  const updatedDependentValue =
    prevProps.formik.values[prevProps.dependsOn] !==
    props.formik.values[prevProps.dependsOn];
  const updatedValue = prevProps.value !== props.value;
  return updatedValue || updatedDependentValue;
};

class CustomOpenStreetMap {
  constructor(options = { providerKey: null, searchBounds: [] }) {
    let { searchBounds } = options;
    //Bounds are expected to be a nested array of [[sw_lat, sw_lng],[ne_lat, ne_lng]].
    // We convert them into a string of 'x1,y1,x2,y2' which is the opposite way around from lat/lng - it's lng/lat
    let boundsUrlComponent = "";
    let regionUrlComponent = "";
    if (searchBounds.length) {
      const reversed = searchBounds.map((el) => {
        return el.reverse();
      });
      this.bounds = [].concat([], ...reversed).join(",");
      boundsUrlComponent = `&bounded=1&viewbox=${this.bounds}`;
    }
    if ("region" in options) {
      regionUrlComponent = `&countrycodes=${options.region}`;
    }
    this.url = `https://nominatim.openstreetmap.org/search?format=json&addressdetails=1&polygon_svg=1&namedetails=1${boundsUrlComponent}${regionUrlComponent}&q=`;
  }

  async search(query) {
    // console.log(this.url + query)
    const response = await fetch(this.url + query).then((res) => res.json());
    return this.formatResponse(response);
  }

  formatResponse(response) {
    const resources = response;
    const count = response.length;
    const info =
      count > 0
        ? resources.map((e) => ({
            bounds: e.boundingbox.map((bound) => Number(bound)),
            latitude: 0,
            longitude: 0,
            name: "deneme 1",
          }))
        : "Not Found";
    return {
      info: info,
      raw: response,
    };
  }
}

export const larIconPoint = new L.Icon({
  iconUrl: require("./lar_icon.png"),
  iconSize: [20, 20],
});

export const larIconPointRed = new L.Icon({
  iconUrl: require("./lar_icon_red.png"),
  iconSize: [20, 20],
});

class EstablishmentsMap extends React.Component {
  api = new Api();

  constructor() {
    super();
    this.state = {
      zoom: 13,
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.valenceId !== prevProps.valenceId) {
      this.getEstablishmentPositionsByValenceId();
    }
    this.state.establishments = this.props.establishments;
    return null;
  }

  mapStateMod = (info) => {
    this.lol.current.map.flyTo(info);
    this.props.updatePosition({
      lat: info[0],
      lng: info[1],
    });
  };

  updatePosition = (info) => {
    this.props.updatePosition(info.target.getLatLng());
  };

  updateRadius = (event, radius) => {
    this.props.updatePosition({ radius: radius * 1000 });
  };

  lol = React.createRef();

  provider = new CustomOpenStreetMap();

  render() {
    const position = [this.props.position.lat, this.props.position.lng];
    const establishments = (this.props.establishments || [])
      .map((valence) => ({
        lat: valence.establishment.latitude,
        lon: valence.establishment.longitude,
        force_req:
          valence.force_requests || valence.limit_establishments_requests,
        name: valence.establishment.entity.name,
        establishment_name: valence.establishment.name,
        url: valence.establishment.url,
        id: valence.id,
      }))
      .filter((coords) => coords.lat && coords.lon);
    const frontofficeURL = process.env.REACT_APP_FRONTOFFICE_URL;

    if (establishments.length === 0)
      return <CircularProgress color="primary" />;

    return (
      <>
        <Map
          center={position}
          zoom={this.state.zoom}
          scrollWheelZoom={false}
          ref={this.mapRef}
          zoomControl={false}
        >
          <TileLayer
            attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
            url="http://{s}.tile.osm.org/{z}/{x}/{y}.png"
          />
          <ReactLeafletSearchV2
            customProvider={this.provider}
            ref={this.lol}
            position="topleft"
            inputPlaceholder="Custom placeholder"
            showMarker={false}
            zoom={12}
            showPopup={false}
            closeResultsOnClick={true}
            openSearchOnLoad={true}
            // these searchbounds would limit results to only Turkey.
            searchBounds={[
              [42.147667, -6.094452],
              [32.159817, -31.004693],
            ]}
            providerOptions={{
              region: "pt",
            }}
            mapStateModifier={this.mapStateMod.bind(this)}
          />

          <Marker
            draggable={true}
            onDragend={this.updatePosition.bind(this)}
            position={this.props.position}
          ></Marker>

          {establishments.map((establishmentData) => (
            <Marker
              draggable={false}
              position={establishmentData}
              icon={
                establishmentData.force_req ? larIconPointRed : larIconPoint
              }
            >
              <Popup>
                <div>
                  <p>
                    <a
                      href={`${frontofficeURL}pt/valencia/lares-e-residencias/equipamento/${establishmentData.url}`}
                    >
                      {establishmentData.establishment_name}
                    </a>
                  </p>
                  <div
                    class={
                      this.props.countAllAutoAddedEstablishments === 0 ||
                      this.props.countManualNotSentEstablishments > 2
                        ? "d-none"
                        : ""
                    }
                  >
                    <Button
                      onClick={() => {
                        this.props.addEstablishmentValence(
                          establishmentData.id,
                          establishmentData.name,
                          false,
                          true
                        );
                      }}
                      size="small"
                      color="primary"
                      variant="outlined"
                    >
                      Encaminhar
                    </Button>
                  </div>
                </div>
              </Popup>
            </Marker>
          ))}

          <Circle
            center={this.props.position}
            fillColor="blue"
            radius={this.props.position.radius}
          />
          <ZoomControl position="bottomright" />
        </Map>
        <Typography id="label" variant="body2">
          Raio de pesquisa: {this.props.position.radius / 1000} Km
        </Typography>
        <Slider
          onChange={this.updateRadius.bind(this)}
          value={this.props.position.radius / 1000}
          min={1}
          max={50}
          aria-labelledby="label"
          className="slider"
        />
      </>
    );
  }
}

const validationSchema = object().shape({
  //search_closest_parishes: string().required('Obrigatório pelo menos uma Freguesia'), //TODO
  proposed_price: number()
    .positive("Indique um valor maior que 0")
    .integer()
    .required("Obrigatório indicar um valor"),
  //valence_id: string().required('Obrigatório indicar uma valência'), //TODO
});

const handleSubmitting = (fn) => (values, actions) => {
  return fn(values)
    .then(() => actions.setSubmitting(false))
    .catch(() => actions.setSubmitting(false));
};

const optionsToSelect = (options) => {
  return options.map((option) => ({ value: option.id, label: option.name }));
};

const userOptionsToSelect = (options) => {
  return options.map((option) => ({
    value: option.id,
    label: `${option.name} - ${option.email}`,
  }));
};

export const userOptionsPromise = (name) => {
  const api = new Api();
  return api
    .get("/users", { name })
    .then((res) => res.data)
    .then(userOptionsToSelect);
};

const filterResponse = (needles, haystack, accessor) => {
  if (needles.length === 0) {
    return haystack;
  }

  const needlsIds = needles.split(",").map((cty) => +cty);
  return haystack.filter((hay) => {
    return needlsIds.indexOf(+hay[accessor]) > -1;
  });
};

const countiesOptionsPromise = (districts) => {
  const api = new Api();
  return () =>
    api
      .get("/counties", {}, true)
      .then((res) => res.data)
      .then((counties) => filterResponse(districts, counties, "district_code"))
      .then(optionsToSelect);
};

// const countiesOptionsPromise = () => {
//   const api = new Api();
//   return api.get('/counties')
//     .then(res => res.data)
//     .then(optionsToSelect);
// };

const parishesOptionsPromise = (counties) => {
  const api = new Api();
  return () =>
    api
      .get("/parishes", {}, true)
      .then((res) => res.data)
      .then((parishes) => filterResponse(counties, parishes, "county_id"))
      .then(optionsToSelect);
};

const physioIdMap = {
  2: 286,
};

const physioOptionsPromise = (valence_id) => {
  const api = new Api();
  const filter = valence_id
    ? { service_option_id: physioIdMap[valence_id] }
    : {};
  return () =>
    api
      .get("/service_option_values", filter, true)
      .then((res) => res.data)
      .then((dataArray) => dataArray.map((data) => data.service_value))
      .then(optionsToSelect);
};

const nurseryIdMap = {
  2: 285,
};

const nurseryOptionsPromise = (valence_id) => {
  const api = new Api();
  const filter = valence_id
    ? { service_option_id: nurseryIdMap[valence_id] }
    : {};
  return () =>
    api
      .get("/service_option_values", filter, true)
      .then((res) => res.data)
      .then((dataArray) => dataArray.map((data) => data.service_value))
      .then(optionsToSelect);
};

const animationIdMap = {
  2: 288,
};

const animationOptionsPromise = (valence_id) => {
  const api = new Api();
  const filter = valence_id
    ? { service_option_id: animationIdMap[valence_id] }
    : {};
  return () =>
    api
      .get("/service_option_values", filter, true)
      .then((res) => res.data)
      .then((dataArray) => dataArray.map((data) => data.service_value))
      .then(optionsToSelect);
};

const districtsOptionsPromise = () => {
  const api = new Api();
  return api
    .get("/districts")
    .then((res) => res.data)
    .then(optionsToSelect);
};

const valencesOptionsPromise = () => {
  const api = new Api();
  return api
    .get("/valences")
    .then((res) => res.data)
    .then(optionsToSelect);
};

export class EstablishmentFilterForm extends React.Component {
  state = {
    disableOptionFilter: false,
    establishments: [],
    amenitiesFilter: false,
    optionsFilter: true,
    mapFilter: false,
    nameFilter: false,
    nameFilterFirstRound: false,
    map: {
      count: 0,
      maxZoom: 13,
      maxBounds: [
        [-90, -180],
        [90, 180],
      ],
      bounds: [
        {
          lat: 33.100745405144245,
          lng: 24.510498046875,
        },
        {
          lat: 33.100745405144245,
          lng: 46.48315429687501,
        },
        {
          lat: 44.55916341529184,
          lng: 46.48315429687501,
        },
        {
          lat: 44.55916341529184,
          lng: 24.510498046875,
        },
      ],
    },
  };

  mapRef = React.createRef();

  toggleAmenitiesFilter = () => {
    this.setState({ amenitiesFilter: !this.state.amenitiesFilter });
  };

  toggleMapFilter = () => {
    this.setState({
      mapFilter: !this.state.mapFilter,
      nameFilter: false,
      optionsFilter: false,
    });
  };

  toggleNameFilter = () => {
    this.setState({
      nameFilter: !this.state.nameFilter,
      mapFilter: false,
      optionsFilter: false,
    });
  };

  toggleNameFilterFirstRound = () => {
    this.setState({
      nameFilter: !this.state.nameFilter,
      mapFilter: false,
      optionsFilter: false,
    });
    this.setState({ disableOptionFilter: !this.state.disableOptionFilter });
    //
    this.state.nameFilterFirstRound = !this.state.nameFilterFirstRound;
    this.props.enableNameFilter(this.state.nameFilterFirstRound);
    //
    let search_by_name = document.getElementById("search_by_name_id");
    if (search_by_name.className === "grey-disabled") {
      document
        .getElementById("search_by_name_id")
        .classList.remove("grey-disabled");
    } else {
      document
        .getElementById("search_by_name_id")
        .classList.add("grey-disabled");
    }
  };

  toggleOptionsFilter = () => {
    this.setState({
      optionsFilter: !this.state.optionsFilter,
      mapFilter: false,
      nameFilter: false,
    });
  };

  render() {
    const {
      onSubmit,
      onChange,
      search_closest_counties,
      search_all_counties,
      search_closest_parishes,
      min_price,
      max_price,
      valence_id,
      proposed_admission_date,
      proposed_price,
      map_radius,
      map_latitude,
      map_longitude,
      getForm,
      establishments,
      countAllAutoAddedEstablishments,
      countManualAddedEstablishments,
      countManualNotSentEstablishments,
    } = this.props;
    return (
      <Col>
        <Formik
          ref={(node) => getForm && getForm(node)}
          initialValues={{
            search_closest_counties: search_closest_counties || "",
            search_all_counties: search_all_counties || "",
            search_closest_parishes: search_closest_parishes || "",
            min_price: min_price || 0,
            max_price: max_price || 0,
            valence_id: valence_id || 2,
            //proposed_visit_time: proposed_visit_time ? moment(proposed_visit_time).format('YYYY-MM-DD') : proposed_visit_time,
            proposed_admission_date,
            proposed_price: proposed_price || 0,
            nursery: "",
            nursery_option_id: valence_id ? nurseryIdMap[+valence_id] : "",
            physio: "",
            physio_option_id: valence_id ? physioIdMap[+valence_id] : "",
            animation: "",
            animation_option_id: valence_id ? animationIdMap[+valence_id] : "",
            no_schedule_restriction: false,
            sex: "",
            amenities_filter: this.state.amenitiesFilter,
            map_radius: map_radius || 2000,
            map_latitude: map_latitude || 38.7436057,
            map_longitude: map_longitude || -9.2302432,
          }}
          onSubmit={handleSubmitting(onSubmit)}
          validationSchema={validationSchema}
          validateOnChange={true}
          validateOnBlur={true}
          render={({
            values,
            errors,
            status,
            touched,
            handleBlur,
            handleChange,
            handleSubmit,
            isSubmitting,
            setFieldValue,
            setFieldTouched,
          }) => {
            //console.log('form', { map_radius, map_latitude, map_longitude });
            onChange({
              ...values,
              mapa_latitude: values.map_latitude,
              mapa_longitude: values.map_longitude,
              name_filter:
                this.state.nameFilter && values.name_search ? true : false,
              map_filter: this.state.mapFilter,
              amenities_filter: this.state.amenitiesFilter,
              options_filter: this.state.optionsFilter,
            });
            return (
              <Form onSubmit={handleSubmit}>
                <Grid container spacing={4}>
                  {/* on click volta aos valores default do mapa*/}
                  <div
                    onClick={() => {
                      values.map_latitude = "38.7436057";
                      values.map_longitude = "-9.2302432";
                    }}
                  >
                    {/* Options filter */}
                    <Grid
                      item
                      md={12}
                      onClick={
                        this.state.disableOptionFilter === true
                          ? ""
                          : this.toggleOptionsFilter
                      }
                    >
                      <span
                        style={{ marginLeft: "17px" }}
                        className={
                          this.state.disableOptionFilter === true
                            ? "grey-disabled"
                            : ""
                        }
                      >
                        {this.state.optionsFilter ? "- " : "+ "}Critérios p/
                        Seleção Automática
                      </span>
                    </Grid>
                  </div>
                  {this.state.optionsFilter && (
                    <>
                      <Grid item md={12}>
                        <Form.Group>
                          <MaterialSelectFormik
                            name="valence_id"
                            placeholder="valence_id"
                            onChange={(field, value) => {
                              setFieldValue(field, value);
                              setFieldValue(
                                "nursery_option_id",
                                nurseryIdMap[+value]
                              );
                              setFieldValue(
                                "physio_option_id",
                                physioIdMap[+value]
                              );
                              setFieldValue(
                                "animation_option_id",
                                animationIdMap[+value]
                              );
                            }}
                            label="Valência"
                            onBlur={setFieldTouched}
                            value={"" + values.valence_id}
                            optionsFetcher={valencesOptionsPromise}
                            required
                          />
                        </Form.Group>
                        <Field
                          name="proposed_price"
                          label="Mensalidade procurada"
                          type="number"
                          inputProps={{ step: 50 }}
                          variant="outlined"
                          margin="none"
                          component={TextField}
                          fullWidth
                          required
                          onChange={setFieldValue}
                          onInput={(e) => {
                            if (!e.target.value) {
                              setFieldValue("min_price", 0);
                              setFieldValue("max_price", 0);
                              return;
                            }
                            setFieldValue(
                              "max_price",
                              Number(e.target.value) + 100
                            );
                            if (e.target.value < 100 && e.target.value > 1)
                              setFieldValue("min_price", 0);
                            else if (e.target.value < 2) {
                              setFieldValue("min_price", 1);
                              setFieldValue("max_price", 10000);
                            } else
                              setFieldValue(
                                "min_price",
                                Number(e.target.value) - 100
                              );
                          }}
                          value={values.proposed_price}
                        />
                      </Grid>
                      <Grid item md={6}>
                        <Field
                          name="min_price"
                          label="Valor mínimo"
                          type="number"
                          inputProps={{ step: 50 }}
                          variant="outlined"
                          margin="none"
                          component={TextField}
                          fullWidth
                          required
                          value={values.min_price}
                          disabled
                        />
                      </Grid>
                      <Grid item md={6}>
                        <Field
                          name="max_price"
                          label="Valor máximo"
                          type="number"
                          inputProps={{ step: 50 }}
                          variant="outlined"
                          margin="none"
                          component={TextField}
                          fullWidth
                          required
                          disabled
                        />
                      </Grid>
                      <Grid item md={12}>
                        <Form.Group
                          onClick={() => {
                            values.search_closest_counties = "";
                            values.search_closest_parishes = "";
                          }}
                        >
                          <FastField
                            name="search_all_counties"
                            placeholder="search_all_counties"
                            label="Distritos"
                            onChange={setFieldValue}
                            onBlur={setFieldTouched}
                            value={values.search_all_counties}
                            optionsFetcher={districtsOptionsPromise}
                            component={MaterialSelectFormik}
                            margin="none"
                          />
                        </Form.Group>
                        <Form.Group
                          onClick={() => {
                            values.search_closest_parishes = "";
                          }}
                        >
                          <FastField
                            name="search_closest_counties"
                            placeholder="search_closest_counties"
                            label="Concelhos Próximos"
                            onChange={setFieldValue}
                            onBlur={setFieldTouched}
                            value={values.search_closest_counties}
                            optionsFetcher={countiesOptionsPromise(
                              values.search_all_counties
                            )}
                            cacheOptions={false}
                            component={MaterialSelectFormik}
                            dependsOn="search_all_counties"
                            shouldUpdate={shouldUpdateSelect}
                            margin="none"
                          />
                        </Form.Group>
                        <Form.Group>
                          <FastField
                            name="search_closest_parishes"
                            placeholder="search_parishes"
                            label="Freguesias *"
                            onChange={setFieldValue}
                            onBlur={setFieldTouched}
                            value={values.search_closest_parishes}
                            limit={20}
                            minLength={3}
                            optionsFetcher={parishesOptionsPromise(
                              values.search_closest_counties
                            )}
                            dependsOn="search_closest_counties"
                            shouldUpdate={shouldUpdateSelect}
                            component={MaterialSelectFormik}
                            margin="none"
                            required
                          />
                          {!values.search_closest_parishes && (
                            <p class="small text-danger">
                              * Obrigatório escolher pelo menos uma freguesia
                            </p>
                          )}
                        </Form.Group>
                      </Grid>
                      <Grid item md={12}>
                        {/* <Field
                        name="proposed_visit_time"
                        label="Data de visita prevista"
                        type="date"
                        variant="outlined"
                        margin="normal"
                        component={TextField}
                        InputLabelProps={{
                          shrink: true
                        }}
                        fullWidth
                        shrink
                      /> */}
                        <Field
                          name="proposed_admission_date"
                          label="Data de admissão prevista"
                          type="date"
                          variant="outlined"
                          margin="normal"
                          component={TextField}
                          fullWidth
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Grid>
                      {+values.valence_id === 2 && (
                        <>
                          <Grid
                            item
                            md={12}
                            onClick={this.toggleAmenitiesFilter}
                          >
                            {this.state.amenitiesFilter ? "- " : "+ "}
                            Comodidades
                          </Grid>
                        </>
                      )}
                      {this.state.amenitiesFilter && (
                        <Grid item md={12}>
                          <Form.Group>
                            <FastField
                              name="nursery"
                              placeholder="nursery"
                              label="Enfermagem"
                              onChange={setFieldValue}
                              onBlur={setFieldTouched}
                              value={values.nursery}
                              isMulti
                              limit={20}
                              minLength={3}
                              optionsFetcher={nurseryOptionsPromise(values.valence_id)}
                              shouldUpdate={false}
                              component={MaterialSelectFormik}
                            />
                          </Form.Group>
                          <Form.Group>
                            <FastField
                              name="physio"
                              placeholder="physio"
                              label="Fisioterapia Personalizada"
                              onChange={setFieldValue}
                              onBlur={setFieldTouched}
                              isMulti
                              value={values.physio}
                              minLength={3}
                              limit={20}
                              optionsFetcher={physioOptionsPromise(values.valence_id)}
                              component={MaterialSelectFormik}
                            />
                          </Form.Group>
                          <Form.Group>
                            <FastField
                              name="animation"
                              placeholder="animation"
                              label="Animação"
                              onChange={setFieldValue}
                              isMulti
                              onBlur={setFieldTouched}
                              value={values.animation}
                              minLength={3}
                              optionsFetcher={animationOptionsPromise(values.valence_id)}
                              component={MaterialSelectFormik}
                            />
                          </Form.Group>

                          <Field
                            name="no_schedule_restriction"
                            Label={{ label: "Sem Restição de Horario Visitas" }}
                            component={CheckboxWithLabel}
                          />
                          <Field
                            name="is_certified"
                            Label={{ label: "Alvará" }}
                            component={CheckboxWithLabel}
                          />
                          <Field
                            name="garden"
                            Label={{ label: "Jardim" }}
                            component={CheckboxWithLabel}
                          />
                        </Grid>
                      )}
                    </>
                  )}
                  {/* Name filter */}
                  <Grid
                    item
                    md={12}
                    onClick={
                      countAllAutoAddedEstablishments === 0
                        ? () => null
                        : this.toggleNameFilter
                    }
                  >
                    <div
                      id="search_by_name_id"
                      class={
                        countAllAutoAddedEstablishments === 0
                          ? "grey-disabled"
                          : ""
                      }
                    >
                      {this.state.nameFilter ? "- " : "+ "}Pesquisa por Nome
                    </div>
                    {countAllAutoAddedEstablishments === 0 &&
                      countManualAddedEstablishments === 0 && (
                        <Tooltip title="A família deseja conhecer apenas este lar">
                          <Grid class="grid_checkbox_name">
                            <Field
                              name="search_by_name_1st_round"
                              onClick={this.toggleNameFilterFirstRound}
                              Label={{ label: "Pedido de um único lar" }}
                              size="small"
                              component={CheckboxWithLabel}
                            />
                          </Grid>
                        </Tooltip>
                      )}
                  </Grid>
                  {this.state.nameFilter && (
                    <Grid item md={12}>
                      <Field
                        name="name_search"
                        label="Procurar Equipamento por nome"
                        type="text"
                        variant="outlined"
                        margin="none"
                        component={TextField}
                        fullWidth
                      />
                    </Grid>
                  )}
                  <Grid item md={12} onClick={this.toggleMapFilter}>
                    <span>
                      {this.state.mapFilter ? "- " : "+ "}Pesquisa pelo Mapa
                    </span>
                  </Grid>
                  {this.state.mapFilter && (
                    <EstablishmentsMap
                      updatePosition={(position) => {
                        if (position.lat)
                          setFieldValue("map_latitude", position.lat);
                        if (position.lng)
                          setFieldValue("map_longitude", position.lng);
                        if (position.radius)
                          setFieldValue("map_radius", position.radius);
                      }}
                      position={{
                        radius: values.map_radius,
                        lat: values.map_latitude,
                        lng: values.map_longitude,
                      }}
                      establishments={establishments}
                      addEstablishmentValence={
                        this.props.addEstablishmentValence
                      }
                      countAllAutoAddedEstablishments={
                        countAllAutoAddedEstablishments
                      }
                      countManualNotSentEstablishments={
                        countManualNotSentEstablishments
                      }
                    />
                  )}
                </Grid>
              </Form>
            );
          }}
        />
      </Col>
    );
  }
}
